import CategoryWeightsForm from "pages/ManagementPage/CategoryWeightsForm/CategoryWeightsForm";

export default CategoryWeightsForm;
